import styled, { css } from 'styled-components';
import { Text } from '~/components/ui/Text';

const StyledContainer = styled.div`
	position: relative;
`;

const StyledImg = styled.img`
	position: absolute;
	top: 50%;
	right: 10px;
	transform: translateY(-50%);
	width: 14px;
	height: 14px;
	user-select: none;
	pointer-events: none;
	transition: filter 0.3s ease;
`;

const StyledReadOnlyContainer = styled.div`
	display: flex;
	align-items: center;
	width: 100%;
	height: 40px;
	padding: 0 34px 0 10px;
	background-color: rgba(255, 255, 255, 0.05);
	border: 1px solid rgba(255, 255, 255, 0.1);
	border-radius: 10px;

	${Text} {
		font-family: 'GT Walsheim Pro';
		font-style: normal;
		font-weight: 400;
		font-size: 14px;
		line-height: 16px;
		color: #ffffff;
		transition: opacity 0.3s ease;
	}
`;

const StyledInput = styled.input<{ $readOnly?: boolean }>`
	width: 100%;
	height: 40px;
	padding: 0 34px 0 10px;
	background-color: rgba(255, 255, 255, 0.05);
	border: 1px solid rgba(255, 255, 255, 0.1);
	border-radius: 10px;

	font-family: 'GT Walsheim Pro';
	font-style: normal;
	font-weight: 400;
	font-size: 14px;
	line-height: 16px;
	color: #ffffff;
	transition:
		background-color 0.3s ease,
		color 0.3s ease;

	&::placeholder {
		color: rgba(255, 255, 255, 0.25);
	}

	${(props) =>
		props.$readOnly
			? css`
					cursor: default;
					pointer-events: none;
					user-select: none;
			  `
			: css`
					&:hover {
						background-color: #ffffff;
						color: #000000;

						&::placeholder {
							color: rgba(0, 0, 0, 0.25);
						}

						& ~ ${StyledImg} {
							filter: invert(100%);
						}
					}
			  `}

	&:focus-visible {
		outline: none;
	}
`;

export { StyledContainer, StyledImg, StyledInput, StyledReadOnlyContainer };
